import { useState } from 'react'
import { Bell } from 'lucide-react'
import { command, useConnection, useProject } from '../app/data'
import { dateTime, Empty } from './forms'
import { RequestDetail } from './request'
import { WorkOrderDetail } from './workOrders'
import { appStore, useAppState } from '../app/state'
import { TechnicalWorkDetail } from './ReadinessUI'
import { Modal } from './ui'
export function Notifications() {
  const d = useProject()
  const connection = useConnection()
  const { role } = useAppState()
  const userId = connection.session?.user.id ?? ''
  const [request, setRequest] = useState('')
  const [work, setWork] = useState('')
  const [error, setError] = useState('')
  return (
    <section className="notification-feed">
      <h3>
        <Bell size={18} />
        Уведомления по работам и заявкам
      </h3>
      {error && <p role="alert">{error}</p>}
      {!d.notifications.length && <Empty>Новых событий пока нет</Empty>}
      {[...d.notifications]
        .reverse()
        .slice(0, 50)
        .map((n) => (
          <article className={(n.readBy ?? []).includes(userId) ? 'read' : 'unread'} key={n.id}>
            <strong>{n.title}</strong>
            <p>{n.message}</p>
            <small>{dateTime(n.createdAt)}</small>
            <div className="detail-actions">
              {(n.workOrderId || n.requestId || n.yardRepairId) && (
                <button
                  className="button secondary"
                  onClick={() => {
                    if (n.workOrderId) setWork(n.workOrderId)
                    else if (n.requestId) setRequest(n.requestId)
                    else if (n.yardRepairId) appStore.navigate('yard', { repair: n.yardRepairId })
                  }}
                >
                  Открыть
                </button>
              )}
              {!(n.readBy ?? []).includes(userId) && (
                <button
                  className="button ghost"
                  onClick={async () => {
                    try {
                      await command('notification.read', n.id, {}, crypto.randomUUID())
                    } catch (e) {
                      setError(e instanceof Error ? e.message : 'Не удалось отметить уведомление')
                    }
                  }}
                >
                  Прочитано
                </button>
              )}
            </div>
          </article>
        ))}
      {request && <RequestDetail id={request} onClose={() => setRequest('')} />}{' '}
      {work &&
        (d.workOrders.find((w) => w.id === work)?.technical ? (
          <Modal title="Техническая работа" onClose={() => setWork('')}>
            <TechnicalWorkDetail work={d.workOrders.find((w) => w.id === work)!} />
          </Modal>
        ) : (
          <WorkOrderDetail id={work} mechanic={role === 'mechanic'} onClose={() => setWork('')} />
        ))}
    </section>
  )
}
